export const componentStyleSelector = (state) => state.styles.components
export const iconsStyleSelector = (state) => state.styles.icons
export const accountStyleSelector = (state) => state.styles.accounts
export const authStyleSelector = (state) => state.styles.auth
export const beneficiaryTransferStyleSelector = (state) => state.styles.beneficiaryTransfers
export const branchStyleSelector = (state) => state.styles.branch
export const calculatorStyleSelector = (state) => state.styles.calculator
export const dashboardStyleSelector = (state) => state.styles.dashboard
export const depositStyleSelector = (state) => state.styles.deposits
export const loanStyleSelector = (state) => state.styles.loans
export const offersStyleSelector = (state) => state.styles.offers
export const paydayLoanStyleSelector = (state) => state.styles.paydayLoans
export const paymentStyleSelector = (state) => state.styles.payments
export const quickPayStyleSelector = (state) => state.styles.quickPay
export const requestStyleSelector = (state) => state.styles.requests
export const sendToMobileStyleSelector = (state) => state.styles.sendToMobile
export const settingStyleSelector = (state) => state.styles.settings
export const sidenavStyleSelector = (state) => state.styles.sideNav
